import { render, staticRenderFns } from "./Whatsappcampaign.vue?vue&type=template&id=8073dc24"
import script from "./Whatsappcampaign.vue?vue&type=script&lang=js"
export * from "./Whatsappcampaign.vue?vue&type=script&lang=js"
import style0 from "./Whatsappcampaign.vue?vue&type=style&index=0&id=8073dc24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports